export const ApiEndpoints = Object.freeze({
  createApplication: {
    url: `/student/create/application`,
    method: "POST",
  },
  fetchApplication: {
    url: `/student/fetch/application`,
    method: "GET",
  },
  updatePersonalDetails: {
    url: `/student/update/personal/details`,
    method: "POST",
  },
  updateCourse: {
    url: `/student/update/course`,
    method: "POST",
  },
  updateQualification: {
    url: `/student/update/qualification`,
    method: "POST",
  },
  updateEvidence: {
    url: `/student/update/evidence`,
    method: "POST",
  },
  updateFurtherDetails: {
    url: `/student/update/further/details`,
    method: "POST",
  },
  submitApplication: {
    url: `/student/submit/application`,
    method: "POST",
  },
  submitConsent: {
    url: `/student/submit/consent`,
    method: "POST",
  },
  fetchPersonalDetails: {
    url: `/student/fetch/personal/details`,
    method: "GET",
  },
  fetchAllCourses: {
    url: `/student/fetch/courses`,
    method: "GET",
  },
  fetchStudentCourse: {
    url: `/student/fetch/course`,
    method: "GET",
  },
  fetchQualification: {
    url: `/student/fetch/qualifications`,
    method: "GET",
  },
  fetchFurtherDetails: {
    url: `/student/fetch/further/details`,
    method: "GET"
  },
  deleteCourse: {
    url: `/student/delete/course`,
    method: "POST"
  },
  deleteQualfication: {
    url: `/student/delete/qualification`,
    method: "POST"
  },
  getStudentID: {
    url: `/student/fetch/id`,
    method: "GET"
  },
});
